import { j as e } from "./kezios-design-system.esm172.js";
import t from "./kezios-design-system.esm212.js";
const d = ({
  video: o,
  videoPlaceholder: r
}) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
  "video",
  {
    autoPlay: !0,
    loop: !0,
    muted: !0,
    src: o,
    poster: r,
    className: t.video
  }
) });
export {
  d as VideoWithPlaceholder
};
